import { normalizeColorHex } from '@/lib/utils';
import { DropdownSearchItem } from '@/modules/common/components/molecules/selectors/dropdown';

import { ShortProjectResponse } from '../types/dto/response/short-project-response';

/**
 * Maps ShortProjectResponse DTO to DropdownSearchItem for use in selectors
 * @param dto - Project response from API
 * @returns Dropdown search item with project data
 */
export const mapShortProjectToDropdownItem = (dto: ShortProjectResponse): DropdownSearchItem => {
  return {
    id: String(dto.id),
    name: dto.name,
    avatarLink: dto.logoUrl ?? undefined,
    secondaryText: dto.status ?? undefined,
    colorHex: normalizeColorHex(dto.colorHex),
    // Status + archive dates drive the dropdown's "Archived" badge and the
    // scheduled archive/unarchive warning icon + tooltip (see project-dropdown-option).
    status: dto.status ?? undefined,
    nextArchiveDate: dto.nextArchiveDate,
    nextUnarchiveDate: dto.nextUnarchiveDate,
  };
};

/**
 * Maps array of ShortProjectResponse DTOs to DropdownSearchItem array
 * @param dtos - Array of project responses from API
 * @returns Array of dropdown search items
 */
export const mapShortProjectsToDropdownItems = (
  dtos: ShortProjectResponse[]
): DropdownSearchItem[] => {
  return dtos.map(mapShortProjectToDropdownItem);
};
